import { ClassifierData } from 'types/classifiers';
import { AddressDto, FuzzySearchResultDto } from 'types/contacts';
import { getClassifierText } from 'utils/getTranslations';

export const formatFullAddress = (
    address: AddressDto | null | undefined,
    classifiers?: Record<string, ClassifierData>
): string => {
    if (!address) return '-';

    const countryLabel =
        classifiers?.['COUNTRY'] && address.countryCode
            ? getClassifierText(classifiers['COUNTRY'], address.countryCode)
            : address.countryCode;

    const parts = [address.address1, address.address2, address.cityName, address.zipCode, countryLabel].filter(
        (part) => part && part.trim() !== ''
    );

    return parts.length > 0 ? parts.join(', ') : '-';
};

export const getContactAddress = (result: FuzzySearchResultDto): AddressDto | null | undefined => {
    if (result.partyType === 'PERSON') {
        return result.homeAddress;
    }
    return result.registrationAddress || result.visitingAddress;
};

/**
 * Formats an address into a simple comma-separated string.
 * Use this for inline display without classifier lookup.
 */
export const formatAddressSimple = (address: AddressDto | null | undefined): string => {
    if (!address) return '';
    const parts = [address.address1, address.address2, address.cityName, address.zipCode, address.countryCode].filter(
        Boolean
    );
    return parts.join(', ');
};
